export class TabsTitleStyle {
  size = 'uk-h3';
  color = 'uk-color-black';
  decoration = '';
  decorationColor = '';
  font = 'tb-font-primary';
  alignment = '';
  titleColumnWidth = '';
  contentColumnWidth = 'uk-width-1-1';
  columnGap = '';
  marginTop = 'uk-margin-remove-top';

  static normalize(styles: Partial<TabsTitleStyle>): TabsTitleStyle {
    const pureStyles = new TabsTitleStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.decoration = styles.decoration ?? pureStyles.decoration;
    pureStyles.decorationColor = styles.decorationColor ?? pureStyles.decorationColor;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;
    pureStyles.titleColumnWidth = styles.titleColumnWidth ?? pureStyles.titleColumnWidth;
    pureStyles.contentColumnWidth = styles.contentColumnWidth ?? pureStyles.contentColumnWidth;
    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
